import React from 'react';
import { type TypographyType } from '../../types/common';
import { SkeletonLineMain, SkeletonWrapper } from './skeleton.Styled';

interface SkeletonLineType {
  size?: TypographyType | 'table';
  width?: string;
  className?: string;
  containerClassName?: string;
  id?: string;
}

const SkeletonLine = ({
  size = 'table',
  width,
  className,
  containerClassName,
  id
}: SkeletonLineType): JSX.Element => {
  return (
    <SkeletonWrapper className={containerClassName} id={id}>
      <SkeletonLineMain size={size} width={width ?? '100%'} className={className} />
    </SkeletonWrapper>
  );
};

export default SkeletonLine;
